// extracted by mini-css-extract-plugin
export default {"listagem_titulo":"home_listagem_titulo__h+BSt","listagem_subtitulo":"home_listagem_subtitulo__5L+D9","paragrafo":"home_paragrafo__ERmJq","BannerInt":"home_BannerInt__HEAr0"};